module.exports = __webpack_public_path__ + "static/media/report-background1.a2345091.png";